<template>
  <table
    class="db-checkout-payment-table db-tw-my-4"
    v-if="
      general.payPercentage > 0 &&
      general.payPercentage < 100 &&
      cartSummary &&
      cartSummary.formattedPricing?.payNow !== undefined &&
      cartSummary.formattedPricing?.payLater !== undefined &&
      cartSummary.formattedPricing?.totalReservation !== undefined
    "
  >
    <tbody class="db-tw-block">
      <tr class="db-checkout-payment-table-paynow">
        <th scope="row">
          {{ $t('Pay now ({x}%)', { x: general.payPercentage }) }}
        </th>
        <td>{{ cartSummary.formattedPricing?.payNow }}</td>
      </tr>
      <tr class="db-checkout-payment-table-paylater">
        <th scope="row">
          {{ $t('Pay upon arrival ({x}%)', { x: 100 - general.payPercentage }) }}
        </th>
        <td>{{ cartSummary.formattedPricing?.payLater }}</td>
      </tr>
      <tr>
        <th scope="row">
          {{ $t('Total Reservation') }}
        </th>
        <td>{{ cartSummary.formattedPricing?.totalReservation }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { useConfigurations } from '@/stores/configurations'
import { useCartStore } from '@/stores/cart'
import { storeToRefs } from 'pinia'

const configStore = useConfigurations()
const { general } = storeToRefs(configStore)

const cartStore = useCartStore()
const { cartSummary } = storeToRefs(cartStore)
</script>

<style>
.db-app .db-checkout-payment-table {
  position: relative;
  display: block;
  background-color: var(--db_box_background_color);
  font-size: var(--db_body_text_font_size) !important;
  color: var(--db_box_rate_color);
  padding-block: var(--db-spacer-8);
}

.db-app .db-checkout-payment-table tr:first-child > * {
  padding-block: var(--db-spacer-2) !important;
}

.db-app .db-checkout-payment-table tr:last-child > * {
  padding-block-start: var(--db-spacer-8) !important;
  padding-block-end: var(--db-spacer-2) !important;
}

.db-app .db-checkout-payment-table tr {
  display: flex;
  justify-content: space-between;
  width: 95%;
  margin: auto;
}

.db-app .db-checkout-payment-table th,
.db-app .db-checkout-payment-table td {
  padding-inline: var(--db-spacer-8);
  padding-block: var(--db-spacer-4);
}

.db-app .db-checkout-payment-table-paynow {
  font-weight: bold;
}

.db-app .db-checkout-payment-table-paylater {
  border-bottom: 2px solid var(--db_borders_color);
}
</style>
